import { CountryCode } from "#/utils/CountryCode"
import { useSelector } from "react-redux"
import { getCompanyInfo } from "#/redux/reducers/companyInfo"
import { useGetIsExcludedFromMedicalRecordsConsent } from "#/services/user/hooks/useGetIsExcludedFromMedicalRecordsConsent"
import { useUserRole } from "../../../partner-access/hooks/usePartnerAccess"
import { JourneyData } from "#/types/memberJourney"

const assistedReproductionJourneyStagesWithLikelyKnownClinic: ReadonlySet<string> = new Set([
  "GETTING_READY_START_IVF",
  "ALREADY_STARTED_IVF_CYCLE",
  "RECENTLY_COMPLETED_IVF_CYCLE"
])

export function useMeetsInitialCriteriaToShowArtMedicalRecordsConsent({
  journeyData
}: {
  journeyData: JourneyData
}): boolean {
  const { companyId, parentCompanyId, countryCode, hasIvfRequirements } = useSelector(getCompanyInfo)
  const getIsExcludedFromMedicalRecordsConsent = useGetIsExcludedFromMedicalRecordsConsent()
  const { isPartnerAccessingAccount } = useUserRole()

  const isExcludedFromMedicalRecordsConsent = getIsExcludedFromMedicalRecordsConsent({
    companyId: Number(companyId),
    parentCompanyId: parentCompanyId
  })

  return (
    countryCode === CountryCode.United_States &&
    !hasIvfRequirements &&
    journeyData?.journey === "ASSISTED_REPRODUCTION" &&
    assistedReproductionJourneyStagesWithLikelyKnownClinic.has(journeyData?.journeyStage) &&
    !isExcludedFromMedicalRecordsConsent &&
    !isPartnerAccessingAccount
  )
}
